// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"543":"full-page","790":"forms","845":"profile","930":"tables"}[chunkId] + "-legacy." + {"543":"4bb0568e","790":"6aaec13a","845":"2dccf349","930":"46b9fc53"}[chunkId] + ".js";
};